import { jsxs as m, jsx as r } from "react/jsx-runtime";
import { Radio as k } from "../node_modules/.pnpm/@ariakit_react-core@0.4.18_react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/@ariakit/react-core/esm/__chunks/SQZLCNLX.js";
import { RadioGroup as R } from "../node_modules/.pnpm/@ariakit_react-core@0.4.18_react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/@ariakit/react-core/esm/radio/radio-group.js";
import { RadioProvider as N } from "../node_modules/.pnpm/@ariakit_react-core@0.4.18_react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/@ariakit/react-core/esm/radio/radio-provider.js";
import { useRef as I, useState as P } from "react";
import w from "../_virtual/pencil.js";
import C from "../_virtual/x.js";
import { Input as F } from "../Input/Input.js";
import { cx as f } from "../apps/ui/styled-system/css/cx.js";
import { css as o } from "../apps/ui/styled-system/css/css.js";
function E({
  adornments: h,
  className: v,
  mode: d,
  onModeChange: a,
  onChange: l,
  presets: t,
  value: c,
  ...b
}) {
  const u = I(null), [x, g] = P(
    "preset"
  ), i = (d ?? x) === "custom", _ = (e) => {
    l(e);
  }, y = (e) => {
    l(e);
  }, p = (e) => {
    d === void 0 && g(e), a == null || a(e), e === "preset" && t.length > 0 && !t.find((s) => s.value === c) && t[0] && l(t[0].value);
  };
  return /* @__PURE__ */ m(
    "div",
    {
      className: f(
        o({
          alignItems: "center",
          display: "flex",
          gap: 8,
          height: 38,
          width: "100%"
        }),
        v
      ),
      children: [
        /* @__PURE__ */ r(
          "div",
          {
            className: o({
              display: "flex",
              flex: "1 0 auto",
              height: "100%",
              position: "relative"
            }),
            children: i ? /* @__PURE__ */ r(
              "div",
              {
                className: o({
                  inset: 0,
                  position: "absolute"
                }),
                children: /* @__PURE__ */ r(
                  F,
                  {
                    adornments: h,
                    autoFocus: !0,
                    className: o({
                      borderRadius: 16,
                      flex: 1
                    }),
                    onChange: y,
                    onKeyDown: (e) => {
                      e.key === "Escape" && (e.stopPropagation(), p("preset"), queueMicrotask(() => {
                        var n, s;
                        (s = (n = u.current) == null ? void 0 : n.querySelector("input:checked")) == null || s.focus();
                      }));
                    },
                    size: "medium",
                    value: c,
                    ...b
                  }
                )
              }
            ) : /* @__PURE__ */ r(
              N,
              {
                setValue: (e) => _(e),
                value: c,
                children: /* @__PURE__ */ r(R, { ref: u, children: /* @__PURE__ */ r(
                  "div",
                  {
                    className: o({
                      alignItems: "center",
                      display: "grid",
                      gap: 8,
                      inset: 0,
                      position: "absolute"
                    }),
                    style: {
                      gridTemplateColumns: "repeat(auto-fit, minmax(40px, 1fr))"
                    },
                    children: t.map((e) => (
                      // biome-ignore lint/a11y/noLabelWithoutControl: Radio contains a control
                      /* @__PURE__ */ m(
                        "label",
                        {
                          className: o({
                            display: "block",
                            position: "relative"
                          }),
                          children: [
                            /* @__PURE__ */ r(
                              k,
                              {
                                className: f(
                                  "peer",
                                  o({
                                    // We can't use Ariakit's VisuallyHidden here, as
                                    // it would add an element and prevent using peer
                                    // selectors to style the buttons states. Instead
                                    // we juste place it behind the button-like.
                                    height: 1,
                                    left: "50%",
                                    position: "absolute",
                                    top: "50%",
                                    width: 1
                                  })
                                ),
                                value: e.value
                              }
                            ),
                            /* @__PURE__ */ r(
                              "div",
                              {
                                className: o({
                                  _peerActive: {
                                    transform: "translateY(1px)"
                                  },
                                  _peerChecked: {
                                    borderColor: "var(--color-th_accent)",
                                    borderWidth: 2,
                                    color: "var(--text-color-th_field)"
                                  },
                                  _peerFocusVisible: {
                                    outline: "2px solid var(--color-th_focus)",
                                    outlineOffset: 2
                                  },
                                  alignItems: "center",
                                  background: "var(--background-color-th_base)",
                                  border: "1px solid var(--border-color-th_field)",
                                  borderRadius: "var(--radius-th_medium)",
                                  color: "var(--text-color-th_field-secondary)",
                                  cursor: "pointer!",
                                  display: "flex",
                                  fontSize: 15,
                                  height: 38,
                                  justifyContent: "center",
                                  outline: "none",
                                  position: "relative",
                                  userSelect: "none"
                                }),
                                children: /* @__PURE__ */ r("span", { children: e.label })
                              }
                            )
                          ]
                        },
                        e.value
                      )
                    ))
                  }
                ) })
              }
            )
          }
        ),
        /* @__PURE__ */ r(
          "button",
          {
            className: o({
              _active: {
                transform: "translateY(1px)"
              },
              _focusVisible: {
                outline: "2px solid var(--color-th_focus)",
                outlineOffset: 2
              },
              background: "var(--background-color-th_base)",
              border: "1px solid var(--border-color-th_field)",
              borderRadius: "var(--radius-th_medium)",
              color: "var(--text-color-th_field-secondary)",
              cursor: "pointer!",
              display: "grid",
              flex: "0 0 auto",
              height: 38,
              outline: 0,
              placeItems: "center",
              position: "relative",
              width: 38
            }),
            onClick: () => p(i ? "preset" : "custom"),
            title: i ? "Back to presets" : "Custom value",
            type: "button",
            children: i ? /* @__PURE__ */ r(C, {}) : /* @__PURE__ */ r(w, {})
          }
        )
      ]
    }
  );
}
export {
  E as PresetsInput
};
//# sourceMappingURL=PresetsInput.js.map
